import React from 'react';
import Parser from 'react-html-parser';
import Grow from '@material-ui/core/Grow';
import ButtonBase from '@material-ui/core/ButtonBase';
import CallRounded from '@material-ui/icons/CallRounded';
import ArrowBackRounded from '@material-ui/icons/ArrowBackRounded';
import MailOutlineRounded from '@material-ui/icons/MailOutlineRounded';
import ArrowForwardRounded from '@material-ui/icons/ArrowForwardRounded';
import VerticalAlignTopRounded from '@material-ui/icons/VerticalAlignTopRounded';

import styles from './styles';
import classes from './classes.module.css';
import { guc } from '../../../services/Localisation';
import Component from '../../../ui-components/Component';
import { withResizer } from '../../../HoCs';
import SimpleHeader from '../../../ui-components/Header/Simple';
import { isEmptyList, isEmptyObject, isEmptyString, merge, path } from '../../../utils';
import Footer from '../../../ui-components/Footer';
import WhyJoinOyo from '../../../ui-components/WhyJoinOyoStrip/components/Card';
import { EVENT_ACTIONS, EVENT_CATEGORIES, logEvent, logPageView } from '../../../services/Analytics';
import StatusPositive from '../../../resources/vectors/StatusPositive';
import { getCtaLinkWithUtmParams } from '../../../utils/campaignUtils';

export class Mission1000 extends Component {

    styles = styles;
    containerRef = React.createRef();
    viewRefs = {};
    content_json_key = 'mission_1000_content_json';
    pageEventCaterogy = EVENT_CATEGORIES.MISSION_1000_PAGE;

    parseJsonString = () => {
        try {
            const data = JSON.parse(guc(this.content_json_key));
            this.viewRefs = isEmptyList(path(data, 'tabs')) ? [] : data.tabs.reduce((accu, curr) => ({ ...accu, [curr.id]: React.createRef() }));
            this.viewRefs['overview'] = React.createRef();
            return isEmptyObject(data) ? { isValid: false } : { isValid: true, data };
        } catch (_) {
            console.log('Error parsing partner_prosperity_content_json');
            return { isValid: false };
        }
    }

    state = this.parseJsonString();

    onScroll = e => this.setState({ scrollPos: e.currentTarget.scrollTop });

    componentDidMount = () => {
        if (this.state.isValid) logPageView();
        else this.props.history.replace('/');
    }

    renderHeader = () => <SimpleHeader actions={this.headerActions} homeLinkLabel={guc('list_my_property')} />;

    onLearnMoreClicked = () => logEvent(this.pageEventCaterogy, EVENT_ACTIONS.LEARN_MORE_CLICKED);

    renderImage = () => {
        const { image, leftText, rightText, rightCta, rightCtaHref } = this.state.data;
        return <div style={this.gs('image_containter')}>
            <img style={this.gs('image')} src={image} />
            <div style={this.gs('left_card')}>
                <div style={this.gs('left_card_heading')}>{Parser(leftText)}</div>
            </div>
            <div style={this.gs('card_divider')} />
            <div style={this.gs('right_card')}>
                <div>{Parser(rightText)}</div>
                <a href={getCtaLinkWithUtmParams(rightCtaHref)} onClick={this.onLearnMoreClicked} target='_blank'>
                    <ButtonBase style={this.gs('start_button')}>{rightCta}</ButtonBase>
                </a>
            </div>
        </div>;
    }

    scrollToTab = id => this.containerRef.current.scrollTo({ top: this.viewRefs[id].current.offsetTop - 65, behavior: 'smooth' });

    renderTabs = () => {
        const { tabs } = this.state.data || {};
        return <div style={this.gs('hori_tabs_wrapper')} className='hideScrollbar'><div style={this.gs('hori_tabs')}>
            {!isEmptyList(tabs) && tabs.map(({ id, title }) => <ButtonBase key={id} className='hoverColorGray' style={this.gs('hori_tab')} onClick={() => this.scrollToTab(id)}>{title}</ButtonBase>)}
        </div></div>;
    }

    renderCards = projects => <div style={this.gs('tab_cards')} className='hideScrollbar'>
        <div style={this.gs('tab_cards_padding')} />
        {projects.map(({ title, image, description, highlight_color }, index) =>
            <WhyJoinOyo key={index} title={Parser(title)} image={image} description={Parser(description)} style={merge(this.gs('tab_card'), !isEmptyString(highlight_color) && { borderColor: highlight_color })} />
        )}
        <div style={this.gs('tab_cards_padding')} />
    </div>

    scrollToTabMobile = index => this.containerRef.current.scrollTo({ top: this.viewRefs[this.state.data.tabs[index].id].current.offsetTop, behavior: 'smooth' });

    onCallUsClicked = () => logEvent(this.pageEventCaterogy, EVENT_ACTIONS.CALL_US_LINK_CLICKED);
    onEmailUsClicked = () => logEvent(this.pageEventCaterogy, EVENT_ACTIONS.EMAIL_US_LINK_CLICKED);

    transform = node => {
        if (node.name === 'a') {
            const onClick = node.attribs.id == 'call_link' ? this.onCallUsClicked : this.onEmailUsClicked;
            return <a href={node.attribs.href} target='_blank' style={{ color: 'var(--theme-color)' }} onClick={onClick}><b>{node.attribs.value}</b></a>;
        } else if (node.name === 'tickicon') {
            return <StatusPositive className='absCenter' />;
        }
    }

    renderContent = () => {
        const { tabs } = this.state.data;
        return <>
            {!isEmptyList(tabs) && tabs.map(({ id, title, heading, message, footing, projects }, index) => <div key={id} style={merge(this.gs('tab_content'), index % 2 && this.gs('tab_content_back'))} id={id} ref={this.viewRefs[id]}>
                <div style={merge(this.gs('tab_title_container'), index % 2 && this.gs('tab_title_container_back'))}>
                    {index != 0 && <div style={this.gs('next_section')} onClick={() => this.scrollToTabMobile(index - 1)}><ArrowBackRounded style={{ marginRight: 8, fontSize: 12 }} />Prev</div>}
                    <div style={this.gs('tab_title')}>{title}</div>
                    {index != tabs.length - 1 && <div style={this.gs('next_section')} onClick={() => this.scrollToTabMobile(index + 1)}>Next <ArrowForwardRounded style={{ marginLeft: 8, fontSize: 12 }} /></div>}
                </div>
                {!isEmptyString(heading) && <div style={this.gs('tab_heading')}>{Parser(heading, { transform: this.transform })}</div>}
                {!isEmptyString(message) && <div style={this.gs('tab_message')}>{Parser(message, { transform: this.transform })}</div>}
                {!isEmptyList(projects) && this.renderCards(projects)}
                {!isEmptyString(footing) && <div style={this.gs('tab_footing')}>{Parser(footing, { transform: this.transform })}</div>}
            </div>)}
        </>;
    }

    scrollToTop = () => this.containerRef.current.scrollTo({ top: 0, behavior: 'smooth' });

    renderGoToTopButton = () => <Grow in={this.state.scrollPos > 200}><div style={this.gs('go_to_top')} onClick={this.scrollToTop}>
        <VerticalAlignTopRounded style={{ fontSize: 18, marginRight: 8 }} />Back to top
    </div></Grow>;

    renderFooter = () => <Footer links={this.footerLinks} />;

    headerActions = [
        { Icon: MailOutlineRounded, text: guc('email'), href: guc('email_us_link'), event_action: EVENT_ACTIONS.EMAIL_US_LINK_CLICKED },
        { Icon: CallRounded, text: guc('country_call_number_label'), href: guc('country_call_number_link'), event_action: EVENT_ACTIONS.CALL_US_LINK_CLICKED },
    ];

    footerLinks = [
        { content: guc('list_my_property'), href: '/', event_action: EVENT_ACTIONS.HOME_PAGE_LINK_CLICKED },
        { content: guc('oyo_giveaway'), href: guc('oyo_giveaway_link'), target: '_blank', event_action: EVENT_ACTIONS.OYO_GIVEAWAY_CLICKED }
    ];

    render = () => {
        if (!this.state.isValid) return null;
        return <div style={this.gs('container')} className={classes.container} ref={this.containerRef} onScroll={this.onScroll}>
            {this.renderHeader()}
            {this.renderImage()}
            {this.renderTabs()}
            {this.renderContent()}
            {this.renderGoToTopButton()}
            {this.renderFooter()}
        </div>;
    }

}


export default withResizer(Mission1000);
